import { useEffect, useState } from "react";
import { doRequest } from "../../utils/helper";
import { config } from "../../utils/config";
import { useSelector } from "react-redux";
import CurrentPlanTag from "./CurrentPlanTag";
import { planLines } from "./PlansLines";
import SubscribePlanButton from "./SubscribePlanButton";

export default function PlansList({ yearlySelected }) {
    const userPlanDetails = useSelector(
        (state) => state?.userPlan?.userPlanDetails?.[0]
    );
    const [monthlyPlansList, setMonthlyPlansList] = useState([]);
    const [yearlyPlansList, setYearlyPlansList] = useState([]);

    const getPlansList = async () => {
        try {
            let res = await doRequest({}, "GET", `plan/list`);
            if (+res?.resultFlag === 1) {
                const list = res?.response?.plans;
                console.log("list", list);
                let monthlyUnlimited =
                    list?.find((plan) => plan.id === 6) || {};
                let yearlyUnlimited = list?.find((plan) => plan.id === 7) || {};

                const firstTwoPlans = list.filter(
                    (plan) => plan.id !== 6 && plan.id !== 7
                );

                setMonthlyPlansList([...firstTwoPlans, monthlyUnlimited]);
                setYearlyPlansList([...firstTwoPlans, yearlyUnlimited]);
            }
        } catch (error) {
            console.error("Error fetching plans list:", error);
        }
    };

    useEffect(() => {
        getPlansList();
    }, []);

    const list = yearlySelected ? yearlyPlansList : monthlyPlansList;
    if (!list?.length) return null;
    return (
        <div
            className="row row_sub_flex"
            style={{ minHeight: "max-content", padding: "1rem 0" }}
        >
            {list?.map((plan) => {
                let planUsage = "";
                if (plan?.id === 2) {
                    planUsage = "per Variation Created";
                } else if (plan?.id === 5) {
                    planUsage = "per variation";
                } else if (plan?.id === 6 || plan?.id === 7) {
                    planUsage = `per ${plan.days} days`;
                }
                return (
                    <div className="col-xl-3 col-sm-5">
                        <div className="sub_pos">
                            <img
                                src={`${config.s3BaseUrl}/images/gradcard.png`}
                                className="card_activegrad"
                                alt=""
                            />
                            <div className="sub_card">
                                <div className="sub_trail_flex">
                                    {userPlanDetails?.plan_id === plan?.id && (
                                        <CurrentPlanTag />
                                    )}
                                    <div className="trail_head">
                                        <h4>{plan?.name}</h4>
                                        <h6>{plan?.title}</h6>
                                    </div>
                                    <div className="trail_price">
                                        <h3>
                                            <sup>₹</sup>
                                            {plan?.price} <sub>{planUsage}</sub>
                                        </h3>
                                        <SubscribePlanButton plan={plan} />
                                    </div>
                                </div>
                                <div
                                    dangerouslySetInnerHTML={{
                                        __html: planLines[plan.id],
                                    }}
                                ></div>
                            </div>
                        </div>
                    </div>
                );
            })}
        </div>
    );
}
